import { render, staticRenderFns } from "./addrKeywords2.vue?vue&type=template&id=09944d2b&scoped=true"
import script from "./addrKeywords2.vue?vue&type=script&lang=js"
export * from "./addrKeywords2.vue?vue&type=script&lang=js"
import style0 from "./addrKeywords2.vue?vue&type=style&index=0&id=09944d2b&prod&scoped=true&lang=css"
import style1 from "./addrKeywords2.vue?vue&type=style&index=1&id=09944d2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09944d2b",
  null
  
)

export default component.exports